import io from "socket.io-client";
const socket = io("http://localhost:8080");
// let dev = "http://192.168.12.160:8080";
// const socket = io("http://192.168.12.157:8080");
//const socket = io("https://azc1.node-1.workpoint001.info");
//const socket = io("https://apiv1.a2zcounsel.com");
export default socket;
